import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { EventService } from 'src/app/shared/API-Service/services/event.service';
import { KeywordsService } from 'src/app/shared/API-Service/services/keywords.service';
import { DatePipe } from '@angular/common';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { AngularEditorConfig, AngularEditorModule } from '@kolkov/angular-editor';
@Component({
  selector: 'app-insert-event',
  templateUrl: './insert-event.component.html',
  styleUrls: ['./insert-event.component.css']
})
export class InsertEventComponent implements OnInit {
  htmleditor:any ;
  keyword:object [] = [];
  selectedItems:any = [];
  dropdownSettings: any = {};
  recordtoupdate: any;
  city:any ;
  eventForm : FormGroup;
eventFormData : FormData;
update:boolean = false;
button:boolean = false;
Image: File;
imageLogo: string;
img : string = Image;
editorConfig: AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  height: '200px',
  minHeight: '200px',
  maxHeight: 'auto',
  width: '100%',
  minWidth: '0',
  translate: 'yes',
  enableToolbar: true,
  showToolbar: true,
  placeholder: 'Enter text here...',
  defaultParagraphSeparator: 'p', // Ensure 'p' tag is used for paragraphs
  defaultFontName: 'Arial',
  toolbarHiddenButtons: [['subscript', 'superscript'],
  ['link', 'insertImage', 'insertVideo'],
  ['outdent', 'indent']],
  toolbarPosition: 'top',
  sanitize: false, // Disable sanitization
  outline: false
};
  constructor(private _Router:Router,private _FormBuilder:FormBuilder,
     private _EventService:EventService, private _DatePipe:DatePipe, private _KeywordsService:KeywordsService) {
      this.imageLogo="../../../../../assets/images/upload.png"
      }

     
  ngOnInit(): void {
    this.getkeywords();
    this.initiate();
    this.checkEdit();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'title',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
  }
 
// editorConfig: AngularEditorConfig = {
//   editable: true,
//     spellcheck: true,
//     height: '300px',
//     minHeight: '50',
//     maxHeight: 'auto',
//     width: 'auto',
//     minWidth: '0',
//     translate: 'yes',
//     enableToolbar: true,
//     showToolbar: true,
//     defaultParagraphSeparator: '',
//     defaultFontName: '',
//     defaultFontSize: '',
//     fonts: [
//       {class: 'arial', name: 'Arial'},
//       {class: 'times-new-roman', name: 'Times New Roman'},
//       {class: 'calibri', name: 'Calibri'},
//       {class: 'comic-sans-ms', name: 'Comic Sans MS'}
//     ],
//     customClasses: [
//     {
//       name: 'quote',
//       class: 'quote',
//     },
//     {
//       name: 'redText',
//       class: 'redText'
//     },
//     {
//       name: 'titleText',
//       class: 'titleText',
//       tag: 'h1',
//     },
//   ],
//   uploadWithCredentials: false,
//   sanitize: true,
//   toolbarPosition: 'top',
//   toolbarHiddenButtons: [
//     ['fontSize','undo',
//     'redo',
//     'strikeThrough',
//     'subscript',
//     'superscript',
//     'justifyLeft',
//     'justifyCenter',
//     'justifyRight',
//     'justifyFull',
//     'indent',
//     'outdent','insertUnorderedList',
//     'heading',
//     'fontName', 'fontSize',
//     'textColor',
//     'backgroundColor',
//     'customClasses',
//     'unlink',
//     'insertImage',
//     'insertVideo',
//     'insertHorizontalRule',
//     'removeFormat',
//     'toggleEditorMode']
    
//   ]
// };

  initiate(){
    this.eventForm = this._FormBuilder.group({
      title: ['', Validators.required],
      body: ['', Validators.required],
      videourl : ['', [Validators.required , Validators.pattern(`((http|https)://)(www.)[a-zA-Z0-9.]{1,}(/){1}(.*)`)]],
      location : ['', Validators.required],
      keywords: ['', Validators.required],
      datetimeFrom : ['', Validators.required],
      datetimeTo : ['', Validators.required],
      eventImage : ['', Validators.required],
    });
  }
  checkEdit() {
    this._EventService.Data.subscribe((res) => {
      console.log(res);
      if (res != null) {
        this.selectedItems = res.keywordsNames;
        this.eventForm = this._FormBuilder.group({
          title: [res.title, Validators.required],
          body: [res.body, Validators.required],
          videourl : [res.videoUrl,[Validators.required , Validators.pattern(`((http|https)://)(www.)[a-zA-Z0-9.]{1,}(/){1}(.*)`)]],
          location : [res.location, Validators.required],
          keywords: [this.selectedItems],
          datetimeFrom : [this._DatePipe.transform(res.dateTimeFrom, 'yyyy-MM-dd'), Validators.required],
          datetimeTo : [this._DatePipe.transform(res.dateTimeTo, 'yyyy-MM-dd'), Validators.required],
          eventImage : [res.image, Validators.required],
        });
        this.imageLogo = this.img + res.image;
        // let driver = this.getById(res);
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        console.log(`not found on data`);
        // this.initiate();
      }
     
    });
  }
  getkeywords(){
   this._KeywordsService.Getkeywords().subscribe((res) => {
     this.keyword = res.data; 
   },(err) => {
    console.log('their is a problem');
   },() => {
    console.log('completed');
   })
  }
  onItemSelect(item: any) {
   
    console.log(this.selectedItems);
}
onItemDeSelect(item: any) {
    console.log('onItemDeSelect', item);
    removeItem(item, this.selectedItems);
     
}
onSelectAll(items: any) {
    console.log('onSelectAll', items);
}
onUnSelectAll(items: any) {
    console.log('onSelectAll', items);
}
  insertappenddata(){
    this.eventFormData = new FormData();
    this.eventFormData.append("Title", this.eventForm.value.title);
    this.eventFormData.append("Body", this.eventForm.value.body);
    this.eventFormData.append("VideoUrl", this.eventForm.value.videourl);
    this.eventFormData.append("Location", this.eventForm.value.location);
    this.selectedItems.forEach(element => {
      this.eventFormData.append("Keywords", element.id);   
      });
    this.eventFormData.append("DateTimeFrom", this.eventForm.value.datetimeFrom);
    this.eventFormData.append("DateTimeTo", this.eventForm.value.datetimeTo);
    this.eventFormData.append("EventImage", this.Image);
   
  }
  updateappenddata(){
    this.eventFormData = new FormData();
    this.eventFormData.append("Id", this.recordtoupdate.id);
    this.eventFormData.append("Title", this.eventForm.value.title);
    this.eventFormData.append("Body", this.eventForm.value.body);
    this.eventFormData.append("VideoUrl", this.eventForm.value.videourl);
    this.eventFormData.append("Location", this.eventForm.value.location);
    this.selectedItems.forEach(element => {
      this.eventFormData.append("Keywords", element.id);   
      });
    this.eventFormData.append("DateTimeFrom", this.eventForm.value.datetimeFrom);
    this.eventFormData.append("DateTimeTo", this.eventForm.value.datetimeTo);
    this.eventFormData.append("EventImage", this.Image);
  }
  get fc() {
    return this.eventForm.controls;
  }
   // imgFile
   getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
        this.eventForm.get("eventImage").setValue(this.Image)
      };
    }
  }

  onSubmit(){
    this.button = true;
    console.log(this.eventForm.value)
   if(this.update == false && this.eventForm.status == "VALID"){
    this.insertappenddata()
    this._EventService.CreateEvent(this.eventFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.eventForm.reset();
      this._Router.navigate(['/content/admin/ViewEvent']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.eventForm.status == "VALID"){
    this.updateappenddata()
    this._EventService.UpdateEvent(this.eventFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.eventForm.reset();
      this._Router.navigate(['/content/admin/ViewEvent']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.eventForm.markAllAsTouched();
    this.button = false;
   }
  }
  ngOnDestroy(){
    this._EventService.Data.next(null);
     }
}
function removeItem(item: any, selectedItems: any) {
  throw new Error('Function not implemented.');
}

